"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.liftA2 = void 0;
/**
 * Apply a binary function over result of 2 single functions
 *
 * E.g. liftA2(sum, inc, sqr)(2, 2) = (2 + 1) + (2 * 2) = 3+4 = 7
 */
function liftA2(fn, f1, f2) {
    return function (a, b) { return fn(f1(a), f2(b)); };
}
exports.liftA2 = liftA2;
